import { usePresets } from "@/hooks/usePresets";

export function PresetDropdown({
  value,
  onChange,
}: {
  value: string;
  onChange: (key: string) => void;
}) {
  // Fetching presets on mount also acts as the auth gate: a 401 here bounces to /login.
  const { data: presets } = usePresets();
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      aria-label="Эзо-пресет"
      className="rounded-lg border border-line bg-bg-0 px-3 py-2 text-sm text-ink-1 focus:border-accent focus:outline-none"
    >
      <option value="">— пресет —</option>
      {presets?.map((p) => (
        <option key={p.key} value={p.key}>
          {p.label}
        </option>
      ))}
    </select>
  );
}
